import { useMemo } from 'react'
import { Trade, Currency } from 'vvs-sdk'
import { Text, Box } from 'vvs-uikit'
import { computeTradePriceBreakdown, warningSeverity } from 'utils/prices'
import { AutoColumn } from 'components/Layout/Column'
import { CurrencyLogo } from 'components/Logo'
import { RowBetween, RowFixed } from 'components/Layout/Row'
import { TruncatedText } from '../styles'

export default function LimitOrdersModalHeader({
  trade,
  currencies,
  formattedAmounts,
}: {
  trade: Trade
  currencies: {
    input: Currency
    output: Currency
  }
  formattedAmounts: {
    input: string
    output: string
    price: string
  }
}) {
  // const slippageAdjustedAmounts = useMemo(
  //   () => computeSlippageAdjustedAmounts(trade, allowedSlippage),
  //   [trade, allowedSlippage],
  // )
  const { priceImpactWithoutFee } = useMemo(() => computeTradePriceBreakdown(trade), [trade])
  const priceImpactSeverity = warningSeverity(priceImpactWithoutFee)

  // const amount =
  //   trade.tradeType === TradeType.EXACT_INPUT
  //     ? slippageAdjustedAmounts[Field.OUTPUT]?.toSignificant(6)
  //     : slippageAdjustedAmounts[Field.INPUT]?.toSignificant(6)
  // const symbol =
  //   trade.tradeType === TradeType.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol

  // const tradeInfoText =
  //   trade.tradeType === TradeType.EXACT_INPUT
  //     ? t('Output is estimated. You will receive at least %amount% %symbol% or the transaction will revert.', {
  //         amount,
  //         symbol,
  //       })
  //     : t('Input is estimated. You will sell at most %amount% %symbol% or the transaction will revert.', {
  //         amount,
  //         symbol,
  //       })

  // const [estimatedText, transactionRevertText] = tradeInfoText.split(`${amount} ${symbol}`)

  return (
    <AutoColumn gap="sm">
      <Text fontSize="13px">You Pay</Text>
      <RowBetween align="flex-end">
        <RowFixed gap="0px">
          <CurrencyLogo currency={trade.inputAmount.currency} size="24px" style={{ marginRight: '12px' }} />
          <TruncatedText fontSize="24px" color="text">
            {formattedAmounts.input}
          </TruncatedText>
        </RowFixed>
        <RowFixed gap="0px">
          <Text fontSize="24px" ml="10px">
            {currencies.input?.symbol?.toUpperCase()}
          </Text>
        </RowFixed>
      </RowBetween>
      <Box borderBottom="1px solid #F0F8F9" margin="10px 0" />
      <Text fontSize="13px">You Receive</Text>
      <RowBetween align="flex-end">
        <RowFixed gap="0px">
          <CurrencyLogo currency={trade.outputAmount.currency} size="24px" style={{ marginRight: '12px' }} />
          <TruncatedText fontSize="24px" color={priceImpactSeverity > 2 ? 'failure' : 'text'}>
            {formattedAmounts.output}
          </TruncatedText>
        </RowFixed>
        <RowFixed gap="0px">
          <Text fontSize="24px" ml="10px">
            {currencies.output?.symbol?.toUpperCase()}
          </Text>
        </RowFixed>
      </RowBetween>
      {/* <AutoColumn justify="flex-start" gap="sm" style={{ padding: '24px 0 0 0px' }}>
        <Text small color="textSubtle" textAlign="left" style={{ width: '100%' }}>
          {estimatedText}
          <b>
            {amount} {symbol}
          </b>
          {transactionRevertText}
        </Text>
      </AutoColumn> */}
    </AutoColumn>
  )
}
